module.exports = __webpack_public_path__ + "static/loto5-d6587c740ddc03917caf531daafd1876.png";